import { render, staticRenderFns } from "./ConfigurationByAcademicYear.vue?vue&type=template&id=17e415cc&scoped=true"
import script from "./ConfigurationByAcademicYear.vue?vue&type=script&lang=js"
export * from "./ConfigurationByAcademicYear.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationByAcademicYear.vue?vue&type=style&index=0&id=17e415cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e415cc",
  null
  
)

export default component.exports